import isEmail from 'validator/lib/isEmail';

type Result =
  | {
      error: false;
    }
  | { error: true; errorMessage: string };

export const emailValidator = (email: string): Result => {
  if (!isEmail(email)) {
    return {
      error: true,
      errorMessage: 'Please enter a valid email. E.g. name@domain.com',
    };
  }

  if (email === 'name@domain.com') {
    return {
      error: true,
      errorMessage: 'Use your real email :)',
    };
  }

  return {
    error: false,
  };
};
